import { SortOptions } from '../../../ts/models/sort/CommonSortOptions';
import { CRASSSortOptions } from '../../../ts/models/sort/CrassSortOptions';
import { OptionsDictionary } from '../../../ts/models/sort/SortOptionDefinitions';


export const databaseWithCRASSSortOptions: OptionsDictionary = {
  'relevance': SortOptions.relevance,
  'name': SortOptions.name,
  'workbooks': CRASSSortOptions.downstreamWorkbookCount,
  'datasources': CRASSSortOptions.downstreamDataSourceCount,
  'connectionType': CRASSSortOptions.connectionType,
};